// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"SnackBars_snackbarContainer_3Ktqi","msg":"SnackBars_msg_lcTC-"};